import { gql } from '@apollo/client';

export default gql`
  query SeamlessElementsQuery(
    $category: String!
    $language: String!
    $previewToken: String
  ) {
    seamlessSection(
      category: $category
      language: $language
      previewToken: $previewToken
    ) {
      title
      category
      elements {
        ... on SeamlessElement1Col {
          layout
          content
          contentStyle
          image
          imageStyle
          background
        }
        ... on SeamlessElement2Col {
          layout
          content
          contentPosition
          image
          imageStyle
          background
        }
        ... on SeamlessElement2ColGrid {
          layout
          content
          image
          imageLeft
          imageRight
          contentLeft
          contentRight
          background
        }
      }
    }
  }
`;
